const deployment = process.env.DEPLOYMENT || 'stage';
const isProd = deployment === 'prod' || deployment === 'pc';
const isPreprod = deployment === 'preprod';

const baseUrl = isProd ? 'https://www.liveauctioneers.com' : `https://${deployment}-test.liveauctioneers.com`;
const classicBaseUrl = isProd
    ? 'https://classic.liveauctioneers.com'
    : `https://mainhost-${deployment}.liveauctioneers.com`;
const partnersBaseUrl = isProd
    ? 'https://partners.liveauctioneers.com'
    : `https://hardboiled-${deployment}.liveauctioneers.com`;
const segmentWriteKey = isProd ? 'HoHgffZL05YMRQr7OAzt1zyzp9ySNQnq' : '2VVBXTAj8OAmELKqpJhQBVy8wxquVSE5';
const buildNumber = process.env.BUILD;
const pubNubNotificationsSubscribeKey =
    isProd || isPreprod ? 'sub-c-71b3766a-3f70-11e9-b5cf-1e59042875b2' : 'sub-c-d9b2a484-3ead-11e9-99ed-dea01fda7778';
const pubNubSubscribeKey =
    isProd || isPreprod ? 'sub-c-afcdf614-eb2a-11e7-acf8-26f7716e5467' : 'sub-c-3bc9bd46-1c28-11e8-bb29-5a43d096f02f';
const stripePublishKey = isProd || isPreprod ? 'pk_live_IQCt8ISLv0ih1YlxIWoMbiCs' : 'pk_test_h4oTIGGE4a5mKDPRz8H0gkFT';
const pushSubscriptionPublicKey =
    isProd || isPreprod
        ? 'BDbPi8Ss-Qzv2kKtk_vRtOakCKO6kq8yl28a7T01YYCvrYlDAtwMddarn95s__xQKQcfVpjiV_QQGEFsMWpgVw0'
        : 'BPP9z2ULGB_8xBRpveV7k9wrSY4chY4GaBuD8dPRaevWKwtFKXbrkGyFUMxEe0vv3fEQQtgCm6TFH8KlJajKdRQ';

const globalNotificationClientType = isProd || isPreprod ? 'bidder-web' : 'bidder-web-test';
const baseCuratorImgUrl = 'https://images.liveauctioneers.com/curators';
const curatorImgUrl = isProd || isPreprod ? baseCuratorImgUrl : `${baseCuratorImgUrl}/stage`;

const referralCandy = {
    houseIdForReferrals: 5584,
    id: 'gxctnclfwvd0gv4bazqhums4c',
    secret: '791390824dbf598938847ebaf55cf85c',
};
const helpScout = {
    appId: '9827be813d874afa9701831d0204b81d',
    secret: '1d181a715e6448a08f1ddca582295ae3',
};

const logRocketAppId = 'qsteg9/bidder';

module.exports = {
    baseUrl,
    buildNumber,
    classicBaseUrl,
    curatorImgUrl,
    deployment,
    // disableSSR: true, /* uncomment this line to disable ssr */
    globalNotificationClientType,
    googleApiKey: 'AIzaSyAmAThAjRtRsBG8quyWUuHk7XH_GNbcoRk',
    helpScout,
    host: process.env.HOST || 'localhost',
    logRocketAppId,
    partnersBaseUrl,
    port: process.env.PORT || 3000,
    pubNubNotificationsSubscribeKey,
    pubNubSubscribeKey,
    pushSubscriptionPublicKey,
    referralCandy,
    sailthruCustomerId: '3ae424afe5d152e7a420ba8614f4ba16',
    securePort: process.env.SECURE_PORT || 3443,
    segmentWriteKey,
    stripePublishKey,
    useSignifyd: true,
};
